/* eslint-disable import/no-cycle */
import _ from 'lodash';
import { handleActions } from 'redux-actions';
import { 	
	addIsSyncing, 
	removeIsSyncing, 
	clearIsSyncing,
	
	addIsUnsyncing, 
	removeIsUnsyncing, 
	clearIsUnsyncing,
	
	addIsDeleting, 
	removeIsDeleting, 
	clearIsDeleting,
	
	addIsSelected, 
	removeIsSelected, 
	clearIsSelected,

	addIsDeleted,
	removeIsDeleted,
	clearIsDeleted,

	addIsQueuedForDelete,
	removeIsQueuedForDelete,
	clearIsQueuedForDelete,

	addErrorMessages,
	removeErrorMessages,
	clearErrorMessages,
	
	clear,
} from './actions';
import { initialState } from './initialState';
import {
	selectSurveyGuidMaps,
	selectMapIsSyncing,
	selectMapIsUnsyncing,
	selectMapIsDeleting,
	selectMapErrorMessages,
	selectMapIsSelected,
	selectMapIsQueuedForDelete,
	selectMapIsDeleted,
} from './selectors';


// ************
// PARTS
// ************

const reducerParts = {
	// eslint-disable-next-line no-unused-vars
	[clear]: () => _.cloneDeep(initialState),



	// ************
	// IS SYNCING
	// ************

	[addIsSyncing]: (state, { payload: { timeuuids } }) => {
		if (!timeuuids || !timeuuids.length) {
			return state;
		}
		const _maps = selectSurveyGuidMaps(state);
		const _map = selectMapIsSyncing(state);
		const _mapAdd = timeuuids.reduce((acc, id) => {
			acc[id] = true;
			return acc;
		}, {});

		return {
			...state,
			surveyGuidMaps: {
				..._maps,
				isSyncing: {
					..._map,
					..._mapAdd,
				}
			}

		};
	},

	[removeIsSyncing]: (state, { payload: { timeuuids } }) => {
		if (!timeuuids || !timeuuids.length) {
			return state;
		}
		const _maps = selectSurveyGuidMaps(state);
		const _mapClone = { ...selectMapIsSyncing(state) };
		timeuuids.forEach(id => {
			delete _mapClone[id];
		})
		return {
			...state,
			surveyGuidMaps: {
				..._maps,
				isSyncing: _mapClone
			}
		};
	},

	[clearIsSyncing]: (state) => {
		const _maps = selectSurveyGuidMaps(state);
		return {
			...state,
			surveyGuidMaps: {
				..._maps,
				isSyncing: {}
			}
		};
	},



	// ************
	// IS UNSYNCING
	// ************

	[addIsUnsyncing]: (state, { payload: { timeuuids } }) => {
		if (!timeuuids || !timeuuids.length) {
			return state;
		}
		const _maps = selectSurveyGuidMaps(state);
		const _map = selectMapIsUnsyncing(state);
		const _mapAdd = timeuuids.reduce((acc, id) => {
			acc[id] = true;
			return acc;
		}, {});

		return {
			...state,
			surveyGuidMaps: {
				..._maps,
				isUnsyncing: {
					..._map,
					..._mapAdd,
				}
			}

		};
	},

	[removeIsUnsyncing]: (state, { payload: { timeuuids } }) => {
		if (!timeuuids || !timeuuids.length) {
			return state;
		}
		const _maps = selectSurveyGuidMaps(state);
		const _mapClone = { ...selectMapIsUnsyncing(state) };
		timeuuids.forEach(id => {
			delete _mapClone[id];
		})
		return {
			...state,
			surveyGuidMaps: {
				..._maps,
				isUnsyncing: _mapClone
			}
		};
	},

	[clearIsUnsyncing]: (state) => {
		const _maps = selectSurveyGuidMaps(state);
		return {
			...state,
			surveyGuidMaps: {
				..._maps,
				isUnsyncing: {}
			}
		};
	},



	// ************
	// IS DELETING
	// ************

	[addIsDeleting]: (state, { payload: { timeuuids } }) => {
		if (!timeuuids || !timeuuids.length) {
			return state;
		}
		const _maps = selectSurveyGuidMaps(state);
		const _map = selectMapIsDeleting(state);
		const _mapAdd = timeuuids.reduce((acc, id) => {
			acc[id] = true;
			return acc;
		}, {});

		return {
			...state,
			surveyGuidMaps: {
				..._maps,
				isDeleting: {
					..._map,
					..._mapAdd,
				}
			}

		};
	},

	[removeIsDeleting]: (state, { payload: { timeuuids } }) => {
		if (!timeuuids || !timeuuids.length) {
			return state;
		}
		const _maps = selectSurveyGuidMaps(state);
		const _mapClone = { ...selectMapIsDeleting(state) };
		timeuuids.forEach(id => {
			delete _mapClone[id];
		})
		return {
			...state,
			surveyGuidMaps: {
				..._maps,
				isDeleting: _mapClone
			}
		};
	},

	[clearIsDeleting]: (state) => {
		const _maps = selectSurveyGuidMaps(state);
		return {
			...state,
			surveyGuidMaps: {
				..._maps,
				isDeleting: {}
			}
		};
	},



	// ************
	// IS DELETED
	// ************

	[addIsDeleted]: (state, { payload: { timeuuids } }) => {
		if (!timeuuids || !timeuuids.length) {
			return state;
		}
		const _maps = selectSurveyGuidMaps(state);
		const _map = selectMapIsDeleted(state);
		const _mapAdd = timeuuids.reduce((acc, id) => {
			acc[id] = true;
			return acc;
		}, {});

		return {
			...state,
			surveyGuidMaps: {
				..._maps,
				isDeleted: {
					..._map,
					..._mapAdd,
				}
			}

		};
	},

	[removeIsDeleted]: (state, { payload: { timeuuids } }) => {
		if (!timeuuids || !timeuuids.length) {
			return state;
		}
		const _maps = selectSurveyGuidMaps(state);
		const _mapClone = { ...selectMapIsDeleted(state) };
		timeuuids.forEach(id => {
			delete _mapClone[id];
		})
		return {
			...state,
			surveyGuidMaps: {
				..._maps,
				isDeleted: _mapClone
			}
		};
	},

	[clearIsDeleted]: (state) => {
		const _maps = selectSurveyGuidMaps(state);
		return {
			...state,
			surveyGuidMaps: {
				..._maps,
				isDeleted: {}
			}
		};
	},



	// ************
	// IS QUEUED FOR DELETE
	// ************

	[addIsQueuedForDelete]: (state, { payload: { timeuuids } }) => {
		if (!timeuuids || !timeuuids.length) {
			return state;
		}
		const _maps = selectSurveyGuidMaps(state);
		const _map = selectMapIsQueuedForDelete(state);
		const _mapAdd = timeuuids.reduce((acc, id) => {
			acc[id] = true;
			return acc;
		}, {});

		return {
			...state,
			surveyGuidMaps: {
				..._maps,
				isQueuedForDelete: {
					..._map,
					..._mapAdd,
				}
			}

		};
	},

	[removeIsQueuedForDelete]: (state, { payload: { timeuuids } }) => {
		if (!timeuuids || !timeuuids.length) {
			return state;
		}
		const _maps = selectSurveyGuidMaps(state);
		const _mapClone = { ...selectMapIsQueuedForDelete(state) };
		timeuuids.forEach(id => {
			delete _mapClone[id];
		})
		return {
			...state,
			surveyGuidMaps: {
				..._maps,
				isQueuedForDelete: _mapClone
			}
		};
	},

	[clearIsQueuedForDelete]: (state) => {
		const _maps = selectSurveyGuidMaps(state);
		return {
			...state,
			surveyGuidMaps: {
				..._maps,
				isQueuedForDelete: {}
			}
		};
	},


	// ************
	// IS SELECTED
	// ************

	[addIsSelected]: (state, { payload: { timeuuids } }) => {
		if (!timeuuids || !timeuuids.length) {
			return state;
		}
		const _maps = selectSurveyGuidMaps(state);
		const _map = selectMapIsSelected(state);
		const _mapAdd = timeuuids.reduce((acc, id) => {
			acc[id] = true;
			return acc;
		}, {});

		return {
			...state,
			surveyGuidMaps: {
				..._maps,
				isSelected: {
					..._map,
					..._mapAdd,
				}
			}

		};
	},

	[removeIsSelected]: (state, { payload: { timeuuids } }) => {
		if (!timeuuids || !timeuuids.length) {
			return state;
		}
		const _maps = selectSurveyGuidMaps(state);
		const _mapClone = { ...selectMapIsSelected(state) };
		timeuuids.forEach(id => {
			delete _mapClone[id];
		})
		return {
			...state,
			surveyGuidMaps: {
				..._maps,
				isSelected: _mapClone
			}
		};
	},

	[clearIsSelected]: (state) => {
		const _maps = selectSurveyGuidMaps(state);
		return {
			...state,
			surveyGuidMaps: {
				..._maps,
				isSelected: {}
			}
		};
	},



	// ************
	// ERROR MESSAGES
	// ************

	[addErrorMessages]: (state, { payload: { timeuuids, messages } }) => {
		if (!timeuuids || !timeuuids.length) {
			return state;
		}
		const _maps = selectSurveyGuidMaps(state);
		const _map = selectMapErrorMessages(state);
		const _mapAdd = timeuuids.reduce((acc, id, idx) => {
			acc[id] = messages[idx];
			return acc;
		}, {});

		return {
			...state,
			surveyGuidMaps: {
				..._maps,
				errorMessages: {
					..._map,
					..._mapAdd,
				}
			}
		};
	},

	[removeErrorMessages]: (state, { payload: { timeuuids } }) => {
		if (!timeuuids || !timeuuids.length) {
			return state;
		}
		const _maps = selectSurveyGuidMaps(state);
		const _mapClone = { ...selectMapErrorMessages(state) };
		timeuuids.forEach(id => {
			delete _mapClone[id];
		})
		return {
			...state,
			surveyGuidMaps: {
				..._maps,
				errorMessages: _mapClone
			}
		};
	},

	[clearErrorMessages]: (state) => {
		const _maps = selectSurveyGuidMaps(state);
		return {
			...state,
			surveyGuidMaps: {
				..._maps,
				errorMessages: {}
			}
		};
	},
};

export default handleActions(reducerParts, initialState);
